import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';

import { checkBuildNumber } from './check-build-number';

/** alternative for checking the build number */
export function singleCheckBuildNumber(http: HttpClient): Observable<void> {
    const headers = new HttpHeaders()
        .set('Pragma', 'no-cache')
        .set('Cache-Control', 'no-cache, no-store');
    const params = new HttpParams().set('t', Date.now().toString());

    let baseUrl;
    try {
        baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
    } catch {}

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return http.get(`${baseUrl}app.def.json`, { headers, params }).pipe(
        map((e: AppDef) => e.BUILD),
        tap(checkBuildNumber),
        timeout(2000),
        catchError(() => {
            console.log('latest build number unknown');
            return of(null);
        }),
    );
}
